import { TextInput } from "@/lib/Components/Form/Inputs/TextInput";
import { RegionInput } from "@/app/Common/Components/RegionInput";
import { StateInput } from "@/app/Cities/Cities/Components/StateInput";
import { useFormState } from "@/lib/Components/Form/Hooks/useFormState";
import { UpdateCityInput } from "@/gql/graphql";
import { generateSlug } from "@/lib/Utils/string";
import { TimezoneInput } from "@/lib/Components/Form/Inputs/TimezoneInput";

export function CityForm() {
  const { values, setFieldValue } = useFormState<UpdateCityInput>();

  return (
    <>
      <TextInput
        autoFocus
        name="name"
        label="Name"
        className="col-span-4"
        onChange={(val) => {
          // Auto-generate slug from name
          if (val) {
            const slug = generateSlug(val);
            setFieldValue("slug", slug);
          }
        }}
      />
      <TextInput
        name="slug"
        label="Slug"
        className="col-span-4"
        description="Lowercase and dashes only"
      />
      <div className="col-span-4" />
      <RegionInput
        name={"region"}
        label={"Region"}
        onChange={async (region) => {
          await setFieldValue("state", region);
        }}
      />
      <StateInput name="state" label="State" region={values.region} />
      <TimezoneInput label="Timezone" name="timezone" className="col-span-6" />
    </>
  );
}
